import {action, autorun, observable, runInAction} from 'mobx';

import {CartNotification} from '@udemy/cart';
import {getMessagingStore} from '@udemy/shopping';

import {getConfig} from 'src/features/shopping-client/config';

const notificationStore = getMessagingStore('notifications');

export class NotificationsStore {
    private latestNotification?: CartNotification;
    readonly notifications = observable.array<CartNotification>([]);

    constructor(gettext: (msgid: string) => string) {
        const config = getConfig(gettext);
        const DEFAULT_NOTIFICATION: CartNotification = {
            message: config.errors.default,
            options: {
                reason: 'invalid',
                level: 'info',
            },
            isRemoved: false,
        };
        autorun(() => {
            const onLastMessage = notificationStore.onMessage as CartNotification | null;
            if (onLastMessage && onLastMessage !== this.latestNotification) {
                this.latestNotification = onLastMessage;
                const newNotification = {
                    ...DEFAULT_NOTIFICATION,
                    ...onLastMessage,
                    options: {
                        ...DEFAULT_NOTIFICATION.options,
                        ...onLastMessage.options,
                    },
                };
                runInAction(() => {
                    this.notifications.unshift(newNotification);
                });

                setTimeout(() => {
                    this.remove(newNotification);
                }, config.timing.notificationHide);
            }
        });
    }

    @action
    remove(notification: CartNotification) {
        if (notification.isRemoved) {
            return;
        }
        notification.isRemoved = true;
        this.notifications.splice(this.notifications.indexOf(notification), 1);
    }
}
